import { Endpoint } from '@business/api/endpoint';
import { ProposalDepositAchRequest, ProposalDepositCardRequest } from '@business/entities/proposal';
import { InvoiceRequest, TimeMaterialId } from '@business/entities/tm';
import { TMInvoiceScheduleId, TMInvoiceScheduleResponse } from '@business/entities/tm/TMInvoiceScheduleResponse';
import { R } from '@core/utils/r';
import { TMInvoiceScheduleFormData } from '@modules/timeMaterials/TimeMaterialOverlay/Tabs/Order/AddEditTMInvoiceScheduleModal/AddEditTMInvoiceScheduleModal';

export function fetchInvoices(tmId?: TimeMaterialId) {
  const params = R.objectCompact({ tmId });
  return Endpoint.get<TMInvoiceScheduleResponse[]>(`@gc/tm-invoice-schedules`, { params });
}

export function createInvoice(data: TMInvoiceScheduleFormData) {
  return Endpoint.post<TMInvoiceScheduleResponse>(`@gc/tm-invoice-schedules`, { data });
}

export function updateInvoice(id: TMInvoiceScheduleId, data: TMInvoiceScheduleFormData) {
  return Endpoint.patch<TMInvoiceScheduleResponse>(`@gc/tm-invoice-schedules/${id}`, { data });
}

export function updateScheduleInvoiceDueDate(id: TMInvoiceScheduleId, data: Partial<TMInvoiceScheduleResponse>) {
  return Endpoint.patch<TMInvoiceScheduleResponse>(`@gc/tm-invoice-schedules/due-date/${id}`, { data });
}

export function deleteInvoice(id: TMInvoiceScheduleId) {
  return Endpoint.delete<void>(`@gc/tm-invoice-schedules/${id}`);
}

export function fetchInvoice(id: TMInvoiceScheduleId) {
  return Endpoint.get<TMInvoiceScheduleResponse>(`@gc/tm-invoice-schedules/${id}`);
}

export function payInvoice(data: InvoiceRequest) {
  return Endpoint.post<void>(`@gc/tm-invoice-schedules/pay-invoice`, { data });
}
export function getInvoice(id: TMInvoiceScheduleId) {
  return Endpoint.get<TMInvoiceScheduleResponse>(`@gc/tm-invoice-schedules/invoice/${id}`);
}

export function payWithACH(id: TMInvoiceScheduleId, data: ProposalDepositAchRequest) {
  return Endpoint.post<TMInvoiceScheduleResponse>(`@gc/tm-invoice-payment/ach/${id}`, { data });
}

export function payWithCard(id: TMInvoiceScheduleId, data: ProposalDepositCardRequest) {
  return Endpoint.post<TMInvoiceScheduleResponse>(`@gc/tm-invoice-payment/card/${id}`, { data });
}
